// 폼 필드 타입 정의
export const FORM_FIELD_TYPE = {
  SHORT_TEXT: 'short_text', // 단답형
  LONG_TEXT: 'long_text', // 장문형
  CHECKBOX: 'checkbox', // 체크박스
  RADIO: 'radio', // 라디오 버튼
  TAGS: 'tags', // 태그
  IMAGE_UPLOAD: 'image_upload', // 이미지 업로드
  STATUS: 'status', // 수정중/작성완료
  DIVIDER: 'divider', // 구분선
  CAMP_SELECT: 'camp_select', // 진영 선택
  STAT_INPUT: 'stat_input', // 스탯 설정 (활성화된 스탯 입력)
} as const;

export type FORM_FIELD_TYPE_VALUE =
  typeof FORM_FIELD_TYPE[keyof typeof FORM_FIELD_TYPE];

// 폼 필드 타입별 한글명
export const FORM_FIELD_TYPE_MAP = {
  [FORM_FIELD_TYPE.SHORT_TEXT]: '단답형',
  [FORM_FIELD_TYPE.LONG_TEXT]: '장문형',
  [FORM_FIELD_TYPE.CHECKBOX]: '체크박스',
  [FORM_FIELD_TYPE.RADIO]: '라디오 버튼',
  [FORM_FIELD_TYPE.TAGS]: '태그',
  [FORM_FIELD_TYPE.IMAGE_UPLOAD]: '이미지 업로드',
  [FORM_FIELD_TYPE.STATUS]: '수정중/작성완료',
  [FORM_FIELD_TYPE.DIVIDER]: '구분선',
  [FORM_FIELD_TYPE.CAMP_SELECT]: '진영 선택',
  [FORM_FIELD_TYPE.STAT_INPUT]: '스탯 설정',
} as const;

// 상태 옵션
export const FORM_STATUS = {
  DRAFT: 'draft', // 수정중
  COMPLETED: 'completed', // 작성완료
} as const;

export type FORM_STATUS_VALUE = typeof FORM_STATUS[keyof typeof FORM_STATUS];

export const FORM_STATUS_MAP = {
  [FORM_STATUS.DRAFT]: '수정중',
  [FORM_STATUS.COMPLETED]: '작성완료',
} as const;
